__turbopack_context__.v({
  "embeddedVideo": "Nrj0VG_embeddedVideo",
  "videoBlock": "Nrj0VG_videoBlock",
});
